"use strict";

exports.__esModule = true;
exports.default = digestMiddleware;
function digestMiddleware($rootScope) {
    return function (store) {
        return function (next) {
            return function (action) {
                var res = next(action);
                $rootScope.$evalAsync(res);
                return res;
            };
        };
    };
}


//////////////////
// WEBPACK FOOTER
// ../~/ng-redux/lib/components/digestMiddleware.js
// module id = 1075
// module chunks = 0